<template>
  <div class="filters__body-section">
    <div
        :class="[collapsed ? 'collapsed':'expanded']"
        class="filter">
      <div class="filter__name">
        <div class="filter__name-text">Цена</div>
        <button @click="collapsed = !collapsed"
                class="filter__control-button">
          <svg class="filter__control-button-icon" width="24" height="24" viewBox="0 0 24 24">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 8.882l8.447 4.224-.894 1.788L12 11.118l-7.553 3.776-.894-1.788L12 8.882z"/>
          </svg>
        </button>
      </div>

            <div class="filter__body">
              <div class="filter__range">
                <input @change="changeMinPrice"
                       :min="0"
                       type="text" class="filter__range-value input-v2"
                       :value="min_price">
                <div class="filter__range-label">—</div>
                <input @change="changeMaxPrice"
                       :min="0"
                       type="text" class="filter__range-value input-v2" :value="max_price">
                <div class="filter__range-label filter__range-label_currency">₽</div>
              </div>
            </div>

    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "ByPrice",
  data() {
    return {
      collapsed: false,
    }
  },
  computed: {
    ...mapGetters({
      min_price: 'group_info/GET_MIN_PRICE',
      max_price: 'group_info/GET_MAX_PRICE',
    }),
  },
  methods: {
    changeMinPrice(value) {
      let price = value.target.value
      price = isNaN(parseFloat(price)) ? 0 : price
      this.$store.commit('group_info/SET_MIN_PRICE', price)
      this.$store.dispatch('group_info/FILTER_BY_PRICE')
      window.url_helpers.set_min_price(this.$store.getters["group_info/GET_MIN_PRICE"])

    },
    changeMaxPrice(value) {
      let price = value.target.value
      price = isNaN(parseFloat(price)) ? 0 : price
      this.$store.commit('group_info/SET_MAX_PRICE', price)
      this.$store.dispatch('group_info/FILTER_BY_PRICE')
      window.url_helpers.set_max_price(this.$store.getters["group_info/GET_MAX_PRICE"])
    },
  },
}
</script>
